<template>
    <InformeCard
        :id="titulo"
        :name="titulo"
        collapsable="true"
        :title="titulo"
    >
        <div class="row table-responsive">
            <b-col cols="12">
                <table class="table table-hover text-nowrap">
                    <thead>
                        <tr>
                            <th>N de pedido</th>
                            <th class="text-center">Categoría</th>
                            <th class="text-center">Nombre</th>
                            <th class="text-center">Apellidos</th>
                            <th class="text-center">Método de pago</th>
                            <th class="text-center">Pago a plazos</th>
                            <th class="text-center">Fecha</th>
                            <th class="text-center">Importe</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="fila in detalle">
                            <tr :key="'detalle-' + fila.id">
                                <td>{{ fila.tpv_order }}</td>
                                <td class="text-center">{{ fila.categoria }}</td>
                                <td class="text-center">{{ fila.nombre }}</td>
                                <td class="text-center">{{ fila.apellidos }}</td>
                                <td class="text-center">{{ fila.metodo_pago | formatear_metodo_pago }}</td>
                                <th class="text-center">
                                    <span v-if="fila.plazo" class="mr-2"><i class="text-green fas fa-check-circle"></i></span>
                                    <span v-else class="mr-2"><i class="text-danger fas fa-times-circle"></i></span>
                                </th>
                                <td class="text-center">{{ fila.fecha }}</td>
                                <td class="text-center">{{ fila.importe | formatear_precio }}</td>
                            </tr>
                        </template>
                        <tr class="tr-total lightgray-content">
                            <td colspan="7"><strong>TOTAL</strong></td>
                            <td class="text-center">{{ totales.importe | formatear_precio }}</td>
                        </tr>
                    </tbody>
                </table>
            </b-col>
        </div>
    </InformeCard>
</template>

<script>
import InformeCard from "../InformeCard";

export default {
    props: ['informe', 'detalle', 'titulo', 'totales'],
    components: {
        InformeCard
    }
}
</script>

